<template>
	<sf-data-table
		ref="asPartInfoTable"
		paging
		:pageUnit="groups.pageUnit"
		:totalSize="groups.totalSize"
		:columns="asPartInfoCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		selection
		:customExcel="excelFunc"
		@changedPage="changedPage"
		creatable
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'partNo'">
				<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
					<el-input :value="slotProps.row[slotProps.column.property]" maxlength="10" />
					<span class="unit input-icon">
						<i class="icon-sf-search search-icon" @click="onCausePartPopup(slotProps)" :style="searchStye"></i>
					</span>
				</template>
				<template v-else>
					{{ slotProps.row.partNo }}
				</template>
			</template>
			<!--opCd  -->
			<template v-if="slotProps.column.property === 'opCd'">
				<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
					<el-input :value="slotProps.row[slotProps.column.property]" maxlength="10" />
					<span class="unit input-icon">
						<i
							class="icon-sf-search search-icon"
							@click="onOpCdPopup(slotProps)"
							:style="searchStye"
							:disabled="slotProps.row.opcdflg === 'false'"
						></i>
					</span>
				</template>
				<template v-else>
					{{ slotProps.row.opCd }}
				</template>
			</template>
			<!--strtDd 시작일 -->
			<template v-if="slotProps.column.property === 'strtDd'">
				<template v-if="slotProps.row.opcdflg == 'true' || slotProps.row.rowType === 'add'">
					<div class="position-relative h-100">
						<el-date-picker v-model="slotProps.row[slotProps.column.property]" type="date" format="yyyy-MM-dd" value-format="yyyyMMdd" />
					</div>
				</template>
				<template v-else>
					{{ slotProps.row.strtDd }}
				</template>
			</template>

			<template v-if="slotProps.column.property === 'costErp'">
				<!-- <template v-if="slotProps.row.userYnflg == 'true'"> -->
				<div class="position-relative h-100">
					<el-select
						v-model="slotProps.row[slotProps.column.property]"
						:disabled="slotProps.row.userYnflg == 'false'"
						filterable
					>
						<el-option v-for="option in ynList" :key="option.value" :label="option.label" :value="option.value"> </el-option>
					</el-select>
				</div>
				<!-- </template>
				<template v-else>
					{{ slotProps.row.pwaYn }}
				</template> -->
			</template>

			<!--asCst as부품가 -->
			<template v-if="slotProps.column.property === 'asCst'">
				<div class="position-relative h-100">
					<el-input
						class="pr-2"
						:value="slotProps.row[slotProps.column.property]"
						:readonly="slotProps.row.userYnflg == 'false'"
						@input="val => onChange(val, slotProps)"
					>
					</el-input>
				</div>
			</template>
			<!--Lts LTS-->
			<template v-if="slotProps.column.property === 'lts'">
				<div class="position-relative h-100">
					<el-input
						class="pr-2"
						:value="slotProps.row[slotProps.column.property]"
						:readonly="slotProps.row.userYnflg == 'false'"
						@input="val => onChange(val, slotProps)"
					>
					</el-input>
				</div>
			</template>
			<!--pwaYn 사용여부-->
			<template v-if="slotProps.column.property === 'pwaYn'">
				<!-- <template v-if="slotProps.row.userYnflg == 'true'"> -->
				<div class="position-relative h-100">
					<el-select
						v-model="slotProps.row[slotProps.column.property]"
						:disabled="slotProps.row.userYnflg == 'false'"
						filterable
						:placeholder="getMessage_('QWCC001163')"
					>
						<el-option v-for="option in useYnList" :key="option.value" :label="option.label" :value="option.value"> </el-option>
					</el-select>
				</div>
				<!-- </template>
				<template v-else>
					{{ slotProps.row.pwaYn }}
				</template> -->
			</template>
			<!--usePrd 보증기간-->
			<template v-if="slotProps.column.property === 'usePrd'">
				<div class="position-relative h-100">
					<el-input
						class="pr-2"
						:value="slotProps.row[slotProps.column.property]"
						:readonly="slotProps.row.userYnflg == 'false'"
						@input="val => onChange(val, slotProps)"
					>
					</el-input>
				</div>
			</template>
			<!--milg 보증사용거리-->
			<template v-if="slotProps.column.property === 'milg'">
				<div class="position-relative h-100">
					<el-input
						class="pr-2"
						:value="slotProps.row[slotProps.column.property]"
						:readonly="slotProps.row.userYnflg == 'false'"
						@input="val => onChange(val, slotProps)"
					>
					</el-input>
				</div>
			</template>
			<!--useYn 사용여부-->
			<template v-if="slotProps.column.property === 'useYn'">
				<!-- <template v-if="slotProps.row.userYnflg == 'true'"> -->
				<div class="position-relative h-100">
					<el-select
						v-model="slotProps.row[slotProps.column.property]"
						:disabled="slotProps.row.userYnflg == 'false'"
						filterable
						:placeholder="getMessage_('QWCC001163')"
					>
						<el-option v-for="option in useYnList" :key="option.value" :label="option.label" :value="option.value"> </el-option>
					</el-select>
				</div>
				<!-- </template>
				<template v-else>
					{{ slotProps.row.useYn }}
				</template> -->
			</template>
		</template>

		<template v-slot:actionsLeft>
			<!--추가-->
			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plue" :onClick="addAction">
				{{ getMessage_('SWCC000007') }}
			</sf-button>
			<!--저장-->
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('SWCC000327') }}
			</sf-button>
		</template>
		<template v-slot:actionsRight>
			<!--엑셀업로드-->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel"  :onClick="openModal">
				{{ getMessage_('QWCC000927') }}
			</sf-button>
			<!--엑셀템플릿 다운-->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel"  :onClick="downExcelTemp">
				{{ getMessage_('QWCC001799') }}
			</sf-button>
		</template>
		<template>
	<div class="rightButtons position-absolute">


		<!-- 엑셀업로드 -->
		<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" :onClick="openModal"> {{ getMessage_('QWCC000927') }}</sf-button>

		<!-- 검사상세 템플릿 다운로드 -->
		<sf-button v-if="isButton_(scrId, 'EU')" line icon="file" :onClick="() => this.downExcelTemp('mst')">
			{{ getMessage_('QWCC001799') }}1
		</sf-button>
		<sf-button v-if="isButton_(scrId, 'EU')" line icon="file" :onClick="() => this.downExcelTemp('dtl')">
			{{ getMessage_('QWCC001799') }}2
		</sf-button>
		<!--엑셀 업로드 팝업창 영역 끝-->
		<!-- <excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" /> -->
	</div>
</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import * as yup from 'yup';

/*엑셀다운로드 시작*/
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/

import _ from 'lodash';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			addRowData: {
				rowType: 'add',
				partNo: '', //품번
				partNm: '', //품명
				opCd: '', //op코드
				strtDd: '', //시작일
				asCst: '', //as부품가
				lts: '', //LTS
				pwaYn: '', //pwa 여부
				usePrd: '', //보증기간
				milg: '', //보증사용거리
				useYn: '', //사용여부
				costErp: 'Y'
			},
			searchStye: {
				//그리드 버튼 스타일 지정
				top: '8px',
				right: '7px'
			},
			selGridRowIndex: '',
			ynList: [{'label': 'Y', 'value': 'Y'},{'label': 'N', 'value': 'N'}] 
		};
	},
	components: {
		//SelectCombo
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.gridList;
		},
		asPartInfoCols() {
			return [
				{
					label: '* ' + this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					width: '200px',
					align: 'center',
					custom: true
				},
				{
					label: this.getMessage_('QWCC000957'), // 품명
					prop: 'partNm',
					headerAlign: 'center',
					width: '300px'
				},
				{
					label: '* ' + this.getMessage_('QWCC001096'), // OP코드
					prop: 'opCd',
					width: '150px',
					align: 'center',
					custom: true
				},
				{
					label: '* ' + this.getMessage_('QWCC001807'), // OP코드명
					prop: 'opNm',
					width: '200px',
					headerAlign: 'center',
					sortable: false
				},
				{
					label: '* ' + this.getMessage_('QWCC001167'), // 시작일
					prop: 'strtDd',
					width: '150px',
					align: 'center',
					custom: true
				},
				{
					label: '* ' + this.getMessage_('QWCC002152'), // 同步ERP获取成本
					prop: 'costErp',
					width: '150px',
					align: 'center',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001190'), // AS부품가
					prop: 'asCst',
					width: '100px',
					headerAlign: 'center',
					align: 'right',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001156'), // LTS
					prop: 'lts',
					width: '90px',
					headerAlign: 'center',
					align: 'right',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001189'), // PWA여부
					prop: 'pwaYn',
					width: '100px',
					align: 'center',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001188'), // HTWO 보증조건
					width: '200px',
					align: 'center',
					children: [
						{
							label: this.getMessage_('QWCC001351'), // 보증기간(년)
							prop: 'usePrd',
							width: '100px',
							align: 'right',
							headerAlign: 'center',
							custom: true
						},
						{
							label: this.getMessage_('QWCC001023'), // 보증사용거리(만Km)
							prop: 'milg',
							width: '150px',
							align: 'right',
							headerAlign: 'center',
							custom: true
						}
					]
				},
				{
					label: this.getMessage_('QWCC001163'), // 사용여부
					prop: 'useYn',
					width: '90px',
					align: 'center',
					custom: true
				},
				{
					label: this.getMessage_('QWCC000954'), // 종료일
					prop: 'endDd',
					align: 'center',
					minWidth: '150px'
				}
			];
		},
		asPartInfoExcelCols() {
			return [
				{
					label: '* ' + this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					width: '50px',
					form: {
						type: 'input',
						isDisabled: this.isDisabled //추가된행은 편집을 못하게 한다.
					}
				},
				{
					label: this.getMessage_('QWCC000957'), // 품명
					prop: 'partNm',
					width: '80px'
				},
				{
					label: '* ' + this.getMessage_('QWCC001096'), // OP코드
					prop: 'opCd',
					width: '100px',
					form: {
						type: 'select',
						options: this.opCdList
					}
				},
				{
					label: '* ' + this.getMessage_('QWCC001807'), // OP코드명
					prop: 'opNm',
					width: '100px',
					sortable: false
				},
				{
					label: '* ' + this.getMessage_('QWCC001167'), // 시작일
					prop: 'strtDd',
					width: '80px',
					form: {
						type: 'date'
					}
				},
				{
					label: this.getMessage_('QWCC001190'), // AS부품가
					prop: 'asCst',
					width: '80px',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001156'), // LTS
					prop: 'lts',
					width: '80px',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001189'), // PWA여부
					prop: 'pwaYn',
					width: '80px',
					form: {
						type: 'select',
						options: this.useYnList
					}
				},
				{
					label: this.getMessage_('QWCC001351'), // 보증기간(년)
					prop: 'usePrd',
					width: '80px',
					form: {
						type: 'input',
						isDisabled: this.isDisabled //추가된행은 편집을 못하게 한다.
					}
				},
				{
					label: this.getMessage_('QWCC001023'), // 보증사용거리(만Km)
					prop: 'milg',
					width: '100px',
					form: {
						type: 'input',
						isDisabled: this.isDisabled //추가된행은 편집을 못하게 한다.
					}
				},
				{
					label: this.getMessage_('QWCC001163'), // 사용여부
					prop: 'useYn',
					width: '60px',
					form: {
						type: 'select',
						options: this.useYnList
					}
				},
				{
					label: '* ' + this.getMessage_('QWCC000954'), // 종료일
					prop: 'endDd',
					width: '200px'
				}
			];
		},
		insVali() {
			return yup.object().shape({
				milg: yup //보증사용거리(만KM)
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001023')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001023')])),
				usePrd: yup //보증기간(년)
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001351')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001351')])),
				lts: yup //LTS
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001100')]))
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001100')]))
					.matches(/^[.0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC000068'), [this.getMessage_('QWCC001100')])), //숫자만 입력가능합니다
				asCst: yup //AS 부품가
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001190')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001190')])),
				strtDd: yup //시작일
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001167')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001167')])),
				opCd: yup //OP코드
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001096')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001096')])),
				partNo: yup //품번
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000956')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000956')]))
			});
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		onChange(value, slotProps) {
			const key = slotProps.column.property;
			if (key === 'lts') {
				const arr = value.toString().split('.');
				value = value.replace(/[^.0-9]/g, '');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 2) {
						value = value.slice(0, 2) + '.';
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 2) {
						arr[1] = arr[1].slice(0, 2);
					}
					if (arr[0].length > 3) {
						arr[0] = arr[0].slice(0, 3);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}
				slotProps.row.lts = value;
			} else if (key === 'asCst') {
				// value = value.replace(/[^0-9]/g, '');
				// if (value.length > 5) {
				// 	value = value.slice(0, 5);
				// }
				const arr = value.toString().split('.');
				value = value.replace(/[^.0-9]/g, '');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 6) {
						value = value.slice(0, 6);
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 2) {
						arr[1] = arr[1].slice(0, 2);
					}
					if (arr[0].length > 6) {
						arr[0] = arr[0].slice(0, 6);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}
				slotProps.row[key] = value;
			} else if (key === 'usePrd') {
				value = value.replace(/[^0-9]/g, '');
				if (value.length > 2) {
					value = value.slice(0, 2);
				}
				slotProps.row[key] = value;
			} else if (key === 'milg') {
				value = value.replace(/[^0-9]/g, '');
				if (value.length > 7) {
					value = value.slice(0, 7);
				}
				slotProps.row[key] = value;
			}
		},

		openModal() {
			// 엑셀업로드팝업 호출
			const param = {
				title: this.getMessage_('QWCC001399'), //타이틀바 값 PMC No 엑셀 업로드
				apiGubun: 'AS_PART_INFO', //업무구분값
				fleg: 'I' //INSERT는 i Update U로 만듬
				//param1: '' //
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			queryStr = objectToQuerystring({
				stdDt: this.searchParams.stdDt,
				partNo: this.searchParams.partNo
			});

			const url = `${BASE_URL}/comm/qmsbase/partCost/v1/asPartInfos/excel` + queryStr;

			const params = { url, columns: this.asPartInfoExcelCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		downExcelTemp() {
			let params = {
				//origFileName: 'aspartInfo.xlsx'
				apiGubun: 'AS_PART_INFO'
			};

			this.excelTempDown_(params)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message || this.getMessage_('QWCC001920') //권한이 없거나 다운로드 할 수 없습니다.
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		addAction() {
			//행추가
			let addRowData = { ...this.addRowData };

			this.rows.unshift(addRowData);

			this.$refs.asPartInfoTable.getTable().toggleRowSelection(addRowData);
		},
		getSelectedRows() {
			const defaultObj = this.insVali.cast();
			const rows = this.$refs.asPartInfoTable
				.getSelectedRows()
				.map(row => _(row).omitBy(_.isNull).omitBy(_.isUndefined).defaults(defaultObj).value());
			return rows;
		},
		saveAction() {
			const selected = this.$refs.asPartInfoTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000103'),
					message: this.getMessage_('QWCC000914')
				}); //행을 선택해 주세요. / 수정된 데이터가 없습니다.
				return;
			}
			//벨리데이션체크
			try {
				for (let i = 0; i < selected.length; i++) {
					this.insVali.validateSync(selected[i]);
				}
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000278'), clickFn: this.save }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async save() {
			this.$sf_toggleLoading(true);

			try {
				let selected = this.$refs.asPartInfoTable.getSelectedRows();

				const { code, messageCd } = await this.saveAsPartInfo_(selected);

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				//Table();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		scrNameClick(row) {
			this.editRow = row;
			this.$emit('PopupOpen');
		},
		onCausePartPopup(param) {
			//부품코드 팝업

			this.partNoInput = this.causPartNo;
			this.selGridRowIndex = param.index;
			this.$emit('OpenPopupPartNo', this.partNoInput);
		},
		//OP코드(공통코드)그리드 팝업 오픈 호출
		onOpCdPopup(param) {
			const causPartNo = param.row.partNo;
			const commCd = {
				commCdType: 'OP_CD',
				commCd: param.row.opCd,
				causPartNo: causPartNo,
				title: this.getMessage_('QWCC001096')
			};

			this.selGridRowIndex = param.index; //그리드에서 선택한 해당행의 인덱스.

			this.$emit('OpenGridOpPopup', commCd);
		},
		gridParNoPopUp(param) {
			let dataArr = this.gridList.slice();
			dataArr[this.selGridRowIndex].partNo = param.partNo;
			dataArr[this.selGridRowIndex].partNm = param.partNm;
		},
		gridOpCdPopUp(param) {
			let dataArr = this.gridList.slice();
			dataArr[this.selGridRowIndex].opCd = param.commCd;
			dataArr[this.selGridRowIndex].opNm = param.commCdName;
		}
	}
};
</script>

<style></style>
